//src/components/onboarding/OnboardingWarning.tsx
import { AlertCircle } from "lucide-react";

export function OnboardingWarning() {
  return (
    <></>
    // <div className="rounded-lg p-4 border border-amber-200 bg-amber-50 mt-4">
    //   <h3 className="font-medium text-amber-800 flex items-center mb-2">
    //     <AlertCircle className="h-4 w-4 mr-2" />
    //     Complete verification to access all features
    //   </h3>
    //   <p className="text-sm text-amber-700">
    //     Please complete the verification process with Obi to unlock access to
    //     all application features. The navigation is available but some pages
    //     will be accessible only after verification.
    //   </p>
    // </div>
  );
}
